const settingsUrl = clientId => `accountsettings/v1/settings?clientId=${clientId}`;

export function getUser() {
	try {
		let theUser = JSON.parse(window.sessionStorage.getItem('user'));
		return theUser; // ? theUser : {};
	} catch (e) {
		return {};
	}
}

export function getExpirationTime() {
	const refreshToken = window.sessionStorage.getItem('refreshToken');
	if (refreshToken) {
		const user = JSON.parse(atob(refreshToken.split('.')[1]));
		return user.exp;
	}
}

export function storeUser(resp) {
	const { access_token, refresh_token } = resp.data;
	window.sessionStorage.setItem('accessToken', access_token);
	window.sessionStorage.setItem('refreshToken', refresh_token);

	const user = JSON.parse(atob(access_token.split('.')[1]));
	window.sessionStorage.setItem('user', JSON.stringify(user));

	return user;
}

export function removeUser() {
	window.sessionStorage.removeItem('user');
	window.sessionStorage.removeItem('accessToken');
	window.sessionStorage.removeItem('refreshToken');
}

export function getRefreshToken() {
	return window.sessionStorage.getItem('refreshToken');
}
